import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';
import { SessionInitStatus } from '../../types';
import { LoadingIndicator } from '@/components/loading/LoadingIndicator';
import { ErrorPage } from './ErrorPage';

interface SessionStatusGateProps {
  initStatus: SessionInitStatus;
  /** ウィジェット内などコンテナに収める場合は true。案内/エラー画面の高さを親に追従させる */
  compact?: boolean;
  children: ReactNode;
}

export const SessionStatusGate = ({
  initStatus,
  compact = false,
  children,
}: SessionStatusGateProps) => {
  const { t } = useTranslation();
  const minHeight = compact ? '100%' : undefined;

  switch (initStatus) {
    case SessionInitStatus.READY:
      return <>{children}</>;

    case SessionInitStatus.LOADING:
      return (
        <Box display="flex" h="100%" w="100%" alignItems="center" justifyContent="center">
          <LoadingIndicator size="medium" />
        </Box>
      );

    case SessionInitStatus.UNAUTHENTICATED:
      return (
        <ErrorPage
          title={t('error.unauthenticated.title')}
          message={t('error.unauthenticated.message')}
          minHeight={minHeight}
        />
      );

    case SessionInitStatus.PAID_PLAN_REQUIRED:
      return <ErrorPage minHeight={minHeight} />;

    case SessionInitStatus.ERROR:
      return <ErrorPage errorCode={500} minHeight={minHeight} />;

    default:
      return <ErrorPage errorCode={500} minHeight={minHeight} />;
  }
};
